import React from "react";
import { Button } from "./button";

export default function WarningModal({ onClose }) {
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-gray-800 border-2 border-cyan-500 text-white w-[90vw] max-w-sm rounded-2xl shadow-2xl p-6 sm:p-8 text-center">
        <h2 className="text-xl font-bold text-cyan-400 mb-4">⚠️ Welcome to Regret Roulette</h2>
        <p className="text-sm mb-4 text-gray-200">
          This is a game of chance. <br />
          Please play responsibly.
          <br />
          The outcome of the game is random, and you may lose your $REGRET.
          <br />
          If you experience a compulsion to keep spinning,
          <span className="italic text-red-400"> seek help</span> — or just log off.
        </p>
        <div className="text-right">
          <Button onClick={onClose} className="bg-cyan-500 hover:bg-cyan-400 text-black font-bold">
            I Accept the Regret
          </Button>
        </div>
      </div>
    </div>
  );
}
